import script from "./RegistroPeleador.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistroPeleador.vue?vue&type=script&setup=true&lang=js"

import "./RegistroPeleador.vue?vue&type=style&index=0&id=3ff24675&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ff24675"]])

export default __exports__